import { render, staticRenderFns } from "./SicurezzaMenu.vue?vue&type=template&id=7b6c779d&"
import script from "./SicurezzaMenu.vue?vue&type=script&lang=ts&"
export * from "./SicurezzaMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports